module.exports = __webpack_public_path__ + "static/media/My Universe Opening Image-BikeImage-FOR HTML.8ca67df1.png";